/**
 * Pre-cutover legacy SEO is independent of the global domain/brand cutover.
 * No implicit development enablement: callers must explicitly opt in.
 */
export const LEGACY_SEO_BROWSER_ENV_KEY = "VITE_DRIVESHARE_LEGACY_SEO_ENABLED";

export function isDriveshareLegacySeoEnabled(env) {
  const node = typeof process !== "undefined" && !!process.versions?.node;
  const value = env
    ? env.DRIVESHARE_LEGACY_SEO_ENABLED ?? env.VITE_DRIVESHARE_LEGACY_SEO_ENABLED
    : node ? process.env.DRIVESHARE_LEGACY_SEO_ENABLED
      : import.meta.env?.VITE_DRIVESHARE_LEGACY_SEO_ENABLED;
  return String(value || "").trim().toLowerCase() === "true";
}

/** Current delivery eligibility is mandatory; captured ownership alone is not. */
export function eligibleLegacyCar(car, page) {
  if (!car || !page || page.kind !== "car") return false;
  const origin = car.platform_origin ?? car.platformOrigin;
  const status = car.listing_status ?? car.listingStatus;
  const source = car.source_id ?? car.sourceId;
  return /^(ds|driveshare)$/i.test(String(origin || "")) &&
    String(car.country_code ?? car.countryCode ?? "").toUpperCase() === "US" &&
    status === "active" && source != null &&
    (Object.hasOwn(car, "deleted_at") || Object.hasOwn(car, "deletedAt")) &&
    String(source) === String(page.sourceId) &&
    car.deleted_at == null && car.deletedAt == null &&
    car.deleted_by_owner !== true && car.disabled_by_owner !== true &&
    page.verified === true && page.uniqueIdentity === true &&
    typeof page.legacyPath === "string" &&
    /^\/car\/[^/]+-[1-9]\d*\/?$/.test(page.legacyPath);
}
